import { API, API_v2 } from '@/services/config';
import { request } from '@@/exports';

/**
 * 获取第三方账户列表( table )
 * @param params
 * @param options
 */
export async function getBankAccountsOthersList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    query_all?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBankAccountsOthersList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   修改第三方账户信息
 * @param data
 * @param options
 */
export async function editBankAccountsOthers(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editBankAccountsOthers, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增第三方账户
 * @param data
 * @param options
 */
export async function addBankAccountsOthers(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addBankAccountsOthers, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除第三方账户
 * @param data
 * @param options
 */
export async function delBankAccountsOthers(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delBankAccountsOthers, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

//账户管理
/**
 * 获取账户列表( table )
 * @param params
 * @param options
 */
export async function getBankAccountsList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    query_all?: number;
    not_me?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBankAccountsList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   修改账户信息
 * @param data
 * @param options
 */
export async function editBankAccounts(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editBankAccounts, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增账户
 * @param data
 * @param options
 */
export async function addBankAccounts(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addBankAccounts, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除账户
 * @param data
 * @param options
 */
export async function delBankAccounts(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delBankAccounts, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
//开票信息维护
/**
 * 获取开票信息维护列表( table )
 * @param params
 * @param options
 */
export async function getInvoiceTitleList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string | number;
    query_all?: number;
    search_term?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceTitleList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   修改开票信息维护信息
 * @param data
 * @param options
 */
export async function editInvoiceTitle(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editInvoiceTitle, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增开票信息维护
 * @param data
 * @param options
 */
export async function addInvoiceTitle(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addInvoiceTitle, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除开票信息维护
 * @param data
 * @param options
 */
export async function delInvoiceTitle(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delInvoiceTitle, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
//外经证
/**
 * 获取外经证列表( table )
 * @param params
 * @param options
 */
export async function getCrossRegionalCertList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCrossRegionalCertList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   修改外经证
 * @param data
 * @param options
 */
export async function editCrossRegionalCert(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editCrossRegionalCert, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增外经证
 * @param data
 * @param options
 */
export async function setCrossRegionalCert(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.setCrossRegionalCert, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除外经证
 * @param data
 * @param options
 */
export async function removeCrossRegionalCert(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.removeCrossRegionalCert, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
//开票余额
/**
 * 获取开票余额列表( table )
 * @param params
 * @param options
 */
export async function getInvoiceLimitList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceLimitList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取公司开票详情
 * @param params
 * @param options
 */
export async function getCompanyDetail(
  params: {
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyDetail, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 恢复每月默认额度
 * @param data
 * @param options
 */
export async function clickRecover(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.clickRecover, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 编辑基本额度
 * @param data
 * @param options
 */
export async function editLimit(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    previous_limit?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editLimit, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增临时额度
 * @param data
 * @param options
 */
export async function tempAdd(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    previous_limit?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.tempAdd, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
//合同
/**
 * 获取合同列表( table )
 * @param params
 * @param options
 */
export async function getContractList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    contract_category?: string;
    is_company?: string;
    is_primary?: string;
    query_all?: string;
    project_id?: string;
    is_multiple_tax_rates?: string;
    opposite_tax_num?: string;
    info?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getContractList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 新增合同
 * @param data
 * @param options
 */
export async function addContract(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addContract, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增增补合同
 * @param data
 * @param options
 */
export async function addContractInfo(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API.addContractInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   修改合同
 * @param data
 * @param options
 */
export async function editContract(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editContract, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除合同
 * @param data
 * @param options
 */
export async function delContract(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    contract_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delContract, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取合同列表( table )
 * @param params
 * @param options
 */
export async function getOrdinaryContractList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getOrdinaryContractList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
//完税证明
/**
 * 获取完税证明列表( table )
 * @param params
 * @param options
 */
export async function getDutyPaidProofList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDutyPaidProofList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 新增完税证明base64
 * @param data
 * @param options
 */
export async function addDutyPaidProofBase64(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addDutyPaidProofBase64, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增完税证明
 * @param data
 * @param options
 */
export async function addDutyPaidProof(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addDutyPaidProof, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   修改完税凭证
 * @param data
 * @param options
 */
export async function editDutyPaidProof(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editDutyPaidProof, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除完税凭证
 * @param data
 * @param options
 */
export async function delDutyPaidProof(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delDutyPaidProof, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取完税证明详情列表( table )
 * @param params
 * @param options
 */
export async function getDutyPaidProofDetail(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getDutyPaidProofDetail, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   修改完税凭证详情列表
 * @param data
 * @param options
 */
export async function editTaxCategories(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editTaxCategories, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   修改完税凭证详情列表
 * @param data
 * @param options
 */
export async function moveDutyPaidProof(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.moveDutyPaidProof, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
//发票列表
/**
 * 获取发票列表( table )
 * @param params
 * @param options
 */
export async function getInvoiceList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
    is_bind?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 上传发票
 * @param data
 * @param options
 */
export async function addAndBindInvoiceInput(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addAndBindInvoiceInput, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取发票详情列表( table )
 * @param params
 * @param options
 */
export async function getInvoiceDetailList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    invoice_code?: string;
    invoice_number?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceDetailList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
//发起开票
/**
 * 获取发起开票列表( table )
 * @param params
 * @param options
 */
export async function getMakeInvoiceList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMakeInvoiceList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取开票条件
 * @param params
 * @param options
 */
export async function getProjectTypes(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectTypes, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 发起开票
 * @param data
 * @param options
 */
export async function addMakeInvoice(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addMakeInvoice, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   修改发起开票
 * @param data
 * @param options
 */
export async function editMakeInvoice(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editMakeInvoice, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除发起开票
 * @param data
 * @param options
 */
export async function delMakeInvoice(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delMakeInvoice, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   完成开票任务
 * @param data
 * @param options
 */
export async function someInvoiceCompleteTask(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.someInvoiceCompleteTask, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取发票识别内容
 * @param data
 * @param options
 */
export async function getInvoiceIdentifyContent(
  data: {
    file?: File;
    size?: string;
    url?: string;
    name?: string;
    type?: string;
    invoicetype?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceIdentifyContent, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  二维码发票识别内容
 * @param data
 * @param options
 */
export async function getInvoiceIdentifyContent_ver(
  data: {
    file?: File;
    size?: string;
    url?: string;
    name?: string;
    type?: string;
    qrcode_info?: string;
    invoicetype?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceIdentifyContent_ver, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新发票识别
 * @param data
 * @param options
 */
export async function getInvoiceIdentifyContentExist(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceIdentifyContentExist, {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 设置公司可开票税率
 * @param data
 * @param options
 */
export async function setCompanyTax(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    taxs?: [];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.setCompanyTax, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 查询公司下可开票税率
 * @param params
 * @param options
 */
export async function getCompanyTaxArray(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyTaxArray, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   无任务发票上传
 * @param data
 * @param options
 */
export async function uploadOutputNoTask(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.uploadOutputNoTask, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取开票任务的发票列表
 * @param params
 * @param options
 */
export async function getTaskInvoiceList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTaskInvoiceList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 查询开票任务的多个附件
 * @param params
 * @param options
 */
export async function getInvoiceFileListByInvoiceId(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    query_all?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceFileListByInvoiceId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 查询开票任务中的发票
 * @param data
 * @param options
 */
export async function delTaskInvoice(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    task_id?: string;
    invoice_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delTaskInvoice, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 发起报销
 * @param data
 * @param options
 */
export async function create(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.create, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 查询报销列表
 * @param params
 * @param options
 */
export async function list(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    query_all?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.list, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 流程定义列表
 * @param params
 * @param options
 */
export async function definitions(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    is_full?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.definitions, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 流程定义列表新
 * @param params
 * @param options
 */
export async function getProcessDefinitionsList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    is_full?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProcessDefinitionsList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 添加流程定义
 * @param data
 * @param options
 */
export async function add(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.add, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改流程定义
 * @param data
 * @param options
 */
export async function update(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.update, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除流程定义
 * @param data
 * @param options
 */
export async function deletes(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.deletes, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取流程基点列表
 * @param params
 * @param options
 */
export async function getProcessNodes(
  params: {
    process_id: number | string;
  },
  options?: { [key: string]: any },
) {
  return request(API_v2.processNodes, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 保存流程图数据
 * @param data
 * @param options
 */
export async function saveFlow(
  data: {
    process_id: number | string;
    flow_data: any;
  },
  options?: { [key: string]: any },
) {
  return request(API_v2.saveFlow, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取流程图数据
 * @param params
 * @param options
 */
export async function getFlow(
  params: {
    process_id: number | string;
  },
  options?: { [key: string]: any },
) {
  return request(API_v2.getFlow, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 工资表列表( table )
 * @param params
 * @param options
 */
export async function getWageScheduleListList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getWageScheduleListList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增工资表
 * @param data
 * @param options
 */
export async function addWageScheduleList(
  data: {
    page?: number;
    pageSize?: number;
    field_name: string;
    ids: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addWageScheduleList, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改工资表
 * @param data
 * @param options
 */
export async function editWageScheduleList(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editWageScheduleList, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除工资表
 * @param data
 * @param options
 */
export async function delWageScheduleList(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delWageScheduleList, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取项目详情
 * @param params
 * @param options
 * @returns
 */
export async function getProjectDetail(
  params: {
    project_id: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectDetail, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 内部网来
 * @param params
 * @param options
 */
export async function getFinanceTransactionProjectLogList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    project_id?: string;
    company_id?: string;
    is_revenue?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceTransactionProjectLogList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 银行流水列表
 * @param params
 * @param options
 */
export async function getFinanceTransactionLogList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    company_id?: string;
    query_all?: string;
    can_bind?: string;
    transaction_type?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceTransactionLogList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *
 */
export async function internalCompanyTransfer(
  data: {
    our_account_id: 1;
    counterparty_account_id: 4;
    payDate: '2025-07-13';
    payCause: '11';
    amount: 10;
    remark: '备注';
  },
  options?: { [key: string]: any },
) {
  return request(API_v2.internalCompanyTransfer, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增银行流水
 * @param data
 * @param options
 */
export async function addFinanceTransactionLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceTransactionLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 编辑银行流水
 * @param data
 * @param options
 */
export async function editFinanceTransactionLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editFinanceTransactionLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 非现金流水列表
 * @param params
 * @param options
 */
export async function getFinanceNonCashList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceNonCashList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 贷款记录列表
 * @param params
 * @param options
 */
export async function getFinanceLoanRecordList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    company_id?: string;
    public_private_type?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceLoanRecordList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 还款记录列表
 * @param params
 * @param options
 */
export async function getFinanceLoanRepaymentRecordList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    company_id?: string;
    loan_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceLoanRepaymentRecordList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 编辑银行流水
 * @param data
 * @param options
 */
export async function bindInputInvoiceAddContract(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.bindInputInvoiceAddContract, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取对账单列表
 * @param params
 * @param options
 */
export async function getStatementList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    contract_id?: string | number;
    customer_id?: string | number;
    project_id?: string | number;
    status?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getStatementList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增对账单
 * @param data
 * @param options
 */
export async function addStatement(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addStatement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 编辑对账单
 * @param data
 * @param options
 */
export async function editStatement(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editStatement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除对账单
 * @param data
 * @param options
 */
export async function delStatement(
  data: {
    statement_id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delStatement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取结算单列表
 * @param params
 * @param options
 */
export async function getSettlementList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    contract_id?: string | number;
    customer_id?: string | number;
    status?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getSettlementList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增结算单
 * @param data
 * @param options
 */
export async function addSettlement(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addSettlement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 编辑结算单
 * @param data
 * @param options
 */
export async function editSettlement(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editSettlement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除结算单
 * @param data
 * @param options
 */
export async function delSettlement(
  data: {
    settlement_id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delSettlement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   新增信用贷款
 * @param data
 * @param options
 */
export async function addFinanceLoanRecordCredit(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceLoanRecordCredit, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   新增还款
 * @param data
 * @param options
 */
export async function repayLoan(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.repayLoan, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 合同收付款记录
 * @param params
 * @param options
 */
export async function getContractPaymentRecordList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getContractPaymentRecordList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取往来款账户列表( table )
 * @param params
 * @param options
 */
export async function getFinanceNbwlAccountList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    company_id?: string;
    not_me?: string;
    project_principal?: number | string;
    query_all?: number | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceNbwlAccountList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  充值  提现  转账
 * @param data
 * @param options
 */
export async function addFinanceTransactionNbwlLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceTransactionNbwlLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取账户流水( table )
 * @param params
 * @param options
 */
export async function getFinanceTransactionNbwlLogList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    company_id?: string;
    not_me?: string;
    nbwl_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceTransactionNbwlLogList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 更新账户余额
 * @param params
 * @param options
 */
export async function updateAccountBalance(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.updateAccountBalance, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   行政费用
 * @param params
 * @param options
 */
export async function getFinanceExpensesAdminList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceExpensesAdminList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   获取已删除的行政费用
 * @param params
 * @param options
 */
export async function getFinanceExpensesAdminDelList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceExpensesAdminDelList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  新增行政费用
 * @param data
 * @param options
 */
export async function addFinanceExpensesAdmin(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceExpensesAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  修改行政费用
 * @param data
 * @param options
 */
export async function updateFinanceExpensesAdmin(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.updateFinanceExpensesAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  删除行政费用
 * @param data
 * @param options
 */
export async function deleteFinanceExpensesAdmin(
  data: {
    platform_id?: string | number;
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.deleteFinanceExpensesAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  恢复行政费用
 * @param data
 * @param options
 */
export async function recoverFinanceExpensesAdmin(
  data: {
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request('/api/financeExpensesAdmin/recoverFinanceExpensesAdmin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   扣除/报销
 * @param data
 * @param options
 */
export async function statementFinanceExpensesAdmin(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.statementFinanceExpensesAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   资产流水
 * @param params
 * @param options
 */
export async function getFinanceCashNonCashList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceCashNonCashList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   抵扣
 * @param data
 * @param options
 */
export async function deductionInputInvoice(
  data: {
    ids: (string | number)[];
    project_id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.deductionInputInvoice, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   发票汇总
 * @param params
 * @param options
 */
export async function getInvoiceListAll(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    contract_id?: string;
    invoice_category?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceListAll, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   获取当前日期账户余额
 * @param params
 * @param options
 */
export async function getBankAccountsBalance(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    account_id?: string;
    date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBankAccountsBalance, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  其他费用
 * @param params
 * @param options
 */
export async function getFinanceExpensesOtherList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceExpensesOtherList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *  获取已删除的其他费用
 * @param params
 * @param options
 */
export async function getFinanceExpensesOtherDelList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceExpensesOtherDelList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  新增其他费用
 * @param data
 * @param options
 */
export async function addFinanceExpensesOther(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceExpensesOther, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   扣除/报销
 * @param data
 * @param options
 */
export async function statementFinanceExpensesOther(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.statementFinanceExpensesOther, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  修改其他费用
 * @param data
 * @param options
 */
export async function updateFinanceExpensesOther(
  data: {
    invoice_list: number[];
    platform_id: string | number;
    id: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.updateFinanceExpensesOther, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  删除其他费用
 * @param data
 * @param options
 */
export async function deleteFinanceExpensesOther(
  data: {
    platform_id?: string | number;
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.deleteFinanceExpensesOther, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  恢复其他费用
 * @param data
 * @param options
 */
export async function recoverFinanceExpensesOther(
  data: {
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request('/api/financeExpensesOther/recoverFinanceExpensesOther', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  其他票据
 * @param params
 * @param options
 */
export async function getFinanceBillList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceBillList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  编辑其他票据
 * @param data
 * @param options
 */
export async function updateFinanceBill(
  data: {
    platform_id?: string | number;
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.updateFinanceBill, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  删除其他票据
 * @param data
 * @param options
 */
export async function deleteFinanceBill(
  data: {
    platform_id?: string | number;
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.deleteFinanceBill, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  新增其他票据
 * @param data
 * @param options
 */
export async function addFinanceBill(
  data: {
    platform_id?: string | number;
    id?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceBill, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  获取抵扣数据
 * @param params
 * @param options
 */
export async function getCompanyTaxUse(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyTaxUse, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  抵扣
 * @param data
 * @param options
 */
export async function addFinanceComTaxDeduction(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceComTaxDeduction, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  成本使用
 * @param data
 * @param options
 */
export async function addFinanceComCostUse(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceComCostUse, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  成本记录
 * @param params
 * @param options
 */
export async function getFinanceComCostUseList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceComCostUseList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  抵扣记录
 * @param params
 * @param options
 */
export async function getFinanceComTaxDeductionList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceComTaxDeductionList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 合同下上传进项票
 * @param data
 * @param options
 */
export async function addAndBindInvoiceInputContract(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    taxs?: [];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addAndBindInvoiceInputContract, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 外经证核销
 * @param data
 * @param options
 */
export async function chargeOff(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    invoiced_amount?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.chargeOff, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 撤回外经证核销
 * @param data
 * @param options
 */
export async function recall(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    invoiced_amount?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.recall, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 合同退款
 * @param data
 * @param options
 */
export async function refund(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    counterparty_account_id?: string;
    our_account_id?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.refund, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  绑定合同
 * @param data
 * @param options
 */
export async function bindInvoiceContractBatch(data: any, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.bindInvoiceContractBatch, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   上传公司下对账单
 * @param data
 * @param options
 */
export async function addCompanyReconciliationStatement(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addCompanyReconciliationStatement, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  查看公司下对账单
 * @param params
 * @param options
 */
export async function getCompanyReconciliationStatementList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    account_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyReconciliationStatementList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *  项目上传对账单
 * @param params
 * @param options
 */
export async function getContractAmount(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    contract_id?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getContractAmount, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   项目合同下添加人员
 * @param data
 * @param options
 */
export async function addWagePersonInfo(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addWagePersonInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *  项目下人员列表
 * @param params
 * @param options
 */
export async function getWagePersonInfoList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: string;
    company_id?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getWagePersonInfoList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 *   项目修改人员信息
 * @param data
 * @param options
 */
export async function editWagePersonInfo(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editWagePersonInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 *   项目删除人员信息
 * @param data
 * @param options
 */
export async function delWagePersonInfo(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.delWagePersonInfo, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 发票数据统计
 * @param params
 * @param options
 */
export async function getInvoiceTaxSummary(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceTaxSummary, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 行政税费统计
 * @param params
 * @param options
 */
export async function getExpensesAdminTaxSummary(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getExpensesAdminTaxSummary, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 其他费用统计
 * @param params
 * @param options
 */
export async function getExpensesOtherTaxSummary(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getExpensesOtherTaxSummary, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 进项票据
 * @param params
 * @param options
 */
export async function getBillTaxSummary(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBillTaxSummary, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 销项票根据时间统计
 * @param params
 * @param options
 */
export async function getInvoiceTaxSummaryDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInvoiceTaxSummaryDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 其他票据根据时间统计
 * @param params
 * @param options
 */
export async function getBillTaxSummaryDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBillTaxSummaryDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 行政税费根据时间统计
 * @param params
 * @param options
 */
export async function getExpensesAdminTaxSummaryDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getExpensesAdminTaxSummaryDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 其他费用根据时间统计
 * @param params
 * @param options
 */
export async function getExpensesOtherTaxSummaryDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    invoice_category?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getExpensesOtherTaxSummaryDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 项目流水统计数据
 * @param params
 * @param options
 */
export async function getTransactionProjectSummary(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTransactionProjectSummary, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 项目流水时间统计数据
 * @param params
 * @param options
 */
export async function getTransactionProjectSummaryDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTransactionProjectSummaryDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 银行流水统计数据
 * @param params
 * @param options
 */
export async function getTransactionSummary(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTransactionSummary, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 银行流水时间统计数据
 * @param params
 * @param options
 */
export async function getTransactionSummaryDate(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    start_date?: string;
    end_date?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getTransactionSummaryDate, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 贷款结清
 * @param data
 * @param options
 */
export async function settle(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.settle, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 贷款还款
 * @param data
 * @param options
 */
export async function addRepayLoan(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addRepayLoan, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 项目查询参考数据
 * @param params
 * @param options
 */
export async function getProjectReference(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    project_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectReference, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 合同查询参考数据
 * @param params
 * @param options
 */
export async function getContractReference(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    contract_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getContractReference, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 转入/转出
 * @param data
 * @param options
 */
export async function transferFromNbwlToProject(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.transferFromNbwlToProject, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 项目转项目
 * @param data
 * @param options
 */
export async function transferFromProjectToProject(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.transferFromProjectToProject, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增社保
 * @param data
 * @param options
 */
export async function addFinanceTransactionSocialSecurityLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addFinanceTransactionSocialSecurityLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 社保数据查询
 * @param params
 * @param options
 */
export async function getFinanceTransactionSocialSecurityLogList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    platform_id?: string;
    company_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceTransactionSocialSecurityLogList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 社保缴费
 * @param data
 * @param options
 */
export async function payFinanceTransactionSocialSecurityLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.payFinanceTransactionSocialSecurityLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 社保缴费退款
 * @param data
 * @param options
 */
export async function refundFinanceTransactionSocialSecurityLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.refundFinanceTransactionSocialSecurityLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 完税凭证入库
 * @param data
 * @param options
 */
export async function payDutyPaidProof(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.payDutyPaidProof, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 完税凭证退库
 * @param data
 * @param options
 */
export async function refundDutyPaidProof(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.refundDutyPaidProof, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 行政税费复制
 * @param data
 * @param options
 */
export async function copyFinanceExpensesAdmin(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.copyFinanceExpensesAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 其他费用复制
 * @param data
 * @param options
 */
export async function copyFinanceExpensesOther(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.copyFinanceExpensesOther, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}


/**
 * 其他费用复制
 * @param data
 * @param options
 */
export async function moveInvoice(data: {
  invoice_id: string|number;
  new_project_id: string|number;
}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.moveInvoice, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   新增银行流水
 * @param data
 * @param options
 */
export async function addBankTransactionLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addBankTransactionLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   合同付款 绑定银行流水
 * @param data
 * @param options
 */
export async function addContractReceiptRecordBind(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addContractReceiptRecordBind, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 银行流水查询
 * @param params
 * @param options
 */
export async function getFinanceFlowBindList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
    bank_transaction_id?: string;
    company_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getFinanceFlowBindList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 冲红
 * @param params
 * @param options
 */
export async function reverseFinanceFlowBind(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: number;
    bank_transaction_id?: string;
    company_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.reverseFinanceFlowBind, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   编辑内部往来流水
 * @param data
 * @param options
 */
export async function editFinanceTransactionNbwlLog(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editFinanceTransactionNbwlLog, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   获取个人账户
 * @param params
 * @param options
 */
export async function getUserBankAccountsByCard(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: number;
    id_card?: string;
    bank_transaction_id?: string;
    company_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getUserBankAccountsByCard, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *   新增个人账户
 * @param data
 * @param options
 */
export async function addUserBankAccount(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addUserBankAccount, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   修改个人账户
 * @param data
 * @param options
 */
export async function editUserBankAccount(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editUserBankAccount, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   删除个人账户
 * @param data
 * @param options
 */
export async function delUserBankAccount(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.delUserBankAccount, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *  查询员工列表
 * @param params
 * @param options
 */
export async function getInInsuranceEmployees(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: number;
    id_card?: string;
    bank_transaction_id?: string;
    company_id?: number;
    month?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getInInsuranceEmployees, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 *  离职转出系统
 * @param data
 * @param options
 */
export async function employeeResign(data: Company, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.employeeResign, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 *   临时接口
 * @param params
 * @param options
 */
export async function getBankStatementDetailList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: number;
    id_card?: string;
    bank_transaction_id?: string;
    company_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getBankStatementDetailList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}